module.exports = __webpack_public_path__ + "static/media/logo-light.c39b4e1a.png";